/*
 * @Descripttion:
 * @Author: chenmeng
 * @Date: 2020-02-26 10:10:16
 * @LastEditors: anzhihao anzhihao@longmaosoft.com
 * @LastEditTime: 2023-10-24 11:31:53
 */
/*
* @ home         首页内容
* @ judge        任务-快判任务
* @ crowd        任务-普通任务
* @ team         任务-团队任务
* @ train        任务-练习任务
* @ search       任务-搜索任务
* @ lib          任务-快判-做题
* @ judgecheck   任务-快判-考核
* @ allpro       任务-所有项目
* @ mypro        任务-我参与的项目
* @ join         申请团队
* @ detail       任务详情页
* @ check        审核用户列表
* @ inspect      任务质检
* @ drawcash     个人中心-账户余额
* @ message      个人中心-消息中心
* @ mytask       个人中心-数据汇总-快判任务、练习任务、普通任务列表
* @ income       账务明细页
* @ supplier     供应商认证
* @ layout       页面框架
* @ login        登陆
* @ myteam       我的团队
* @ pkgList      题包明细
* @ TrainV3      培训大厅
* */

export default {
  Home: () => import(/* webpackChunkName: "home" */ '@/views/home.vue'),
  Judge: () => import(/* webpackChunkName: "judge" */ '@/views/task/judge/judge.vue'),
  JudgeLib: () => import(/* webpackChunkName: "judgeLib" */ '@/views/task/judge/judgeLib.vue'),
  JudgeCheck: () => import(/* webpackChunkName: "judgeCheck" */ '@/views/task/judge/judgeCheck.vue'),
  Crowd: () => import(/* webpackChunkName: "crowd" */ '@/views/task/crowd.vue'),
  AuthUser: () => import(/* webpackChunkName: "authUser" */ '@/views/task/authUser.vue'),
  Team: () => import(/* webpackChunkName: "team" */ '@/views/task/team.vue'),
  AllPro: () => import(/* webpackChunkName: "allpro" */ '@/views/project/all.vue'),
  MyPro: () => import(/* webpackChunkName: "myPro" */ '@/views/project/my.vue'),
  ProDetail: () => import(/* webpackChunkName: "myPro" */ '@/views/project/detail.vue'),
  Train: () => import(/* webpackChunkName: "train" */ '@/views/task/train.vue'),
  Search: () => import(/* webpackChunkName: "search" */ '@/views/task/search.vue'),
  Join: () => import(/* webpackChunkName: "join" */ '@/views/task/join.vue'),
  Detail: () => import(/* webpackChunkName: "detail" */ '@/views/task/detail.vue'),
  Check: () => import(/* webpackChunkName: "check" */ '@/views/task/check.vue'),
  Inspect: () => import(/* webpackChunkName: "inspect" */ '@/views/task/inspect.vue'),
  CheckFirst: () => import(/* webpackChunkName: "checkfirst" */ '@/views/task/checkfirst.vue'),
  TrainCheck: () => import(/* webpackChunkName: "judgeCheck" */ '@/views/task/trainCheck.vue'),
  Examine: () => import(/* webpackChunkName: "examine" */ '@/views/task/examine.vue'),
  Drawcash: () => import(/* webpackChunkName: "drawcash" */ '@/views/user/drawcash.vue'),
  Income: () => import(/* webpackChunkName: "income" */ '@/views/user/income.vue'),
  Supplier: () => import(/* webpackChunkName: "supplier" */ '@/views/user/supplier.vue'),
  MarkTags: () => import(/* webpackChunkName: "markTags" */ '@/views/user/data/markTags.vue'),
  AnswerTags: () => import(/* webpackChunkName: "answerTags" */ '@/views/user/data/answerTags.vue'),
  Message: () => import(/* webpackChunkName: "message" */ '@/views/user/message.vue'),
  Account: () => import(/* webpackChunkName: "message" */ '@/views/user/account.vue'),
  TaskDetail: () => import(/* webpackChunkName: "myTask" */ '@/views/user/taskDetail.vue'),
  ExpDetail: () => import(/* webpackChunkName: "star" */ '@/views/user/expDetail.vue'),
  Index: () => import(/* webpackChunkName: "index" */ '@/components/index.vue'),
  Layout: () => import(/* webpackChunkName: "layout" */ '@/components/layout.vue'),
  User: () => import(/* webpackChunkName: "user" */ '@/views/user/index.vue'),
  Login: () => import(/* webpackChunkName: "login" */ '@/views/login.vue'),
  TeamGuide: () => import(/* webpackChunkName: "team_guide" */ '@/views/task/team_guide.vue'),
  Bind: () => import(/* webpackChunkName: "bind" */ '@/views/bind.vue'),
  MyTeamDetail: () => import(/* webpackChunkName: "myTeamDetail" */ '@/views/user/myTeamDetail.vue'),
  MyTeamTask: () => import(/* webpackChunkName: "myTeamTask" */ '@/views/user/data/myTeamTask.vue'),
  ExamRecord: () => import(/* webpackChunkName: "examRecord" */ '@/views/user/data/examRecord.vue'),
  Empower: () => import(/* webpackChunkName: "empower" */ '@/views/user/data/empower.vue'),
  Guarantee: () => import(/* webpackChunkName: "guarantee" */ '@/views/user/data/guarantee.vue'),
  Statistics: () => import(/* webpackChunkName: "statistics" */ '@/views/user/data/statistics.vue'),
  UserInfo: () => import(/* webpackChunkName: "statistics" */ '@/components/account/info.vue'),
  UserProfile: () => import(/* webpackChunkName: "statistics" */ '@/components/account/profile.vue'),
  TopAmount: () => import(/* webpackChunkName: "statistics" */ '@/views/top.vue'),
  ToPkgList: () => import(/* webpackChunkName: "toPkgList" */ '@/views/task/pkgList.vue'),
  Activity: () => import(/* webpackChunkName: "activity" */ '@/views/user/activity.vue'),
  ExamineUser: () => import(/* webpackChunkName: "examineUser" */ '@/views/task/examineUser.vue'),
  ExamineDetail: () => import(/* webpackChunkName: "examineDetail" */ '@/views/task/examineDetail.vue'),
  InspectUser: () => import(/* webpackChunkName: "inspectUser" */ '@/views/task/inspectUser.vue'),
  InspectDetail: () => import(/* webpackChunkName: "inspectDetail" */ '@/views/task/inspectDetail.vue'),
  InspectPackage: () => import(/* webpackChunkName: "inspectPackage" */ '@/views/task/inspectPackage.vue'),
  TrainNew: () => import(/* webpackChunkName: "train" */ '@/views/task/trainNew.vue'),
  TrainDetail: () => import(/* webpackChunkName: "train" */ '@/views/task/trainDetail.vue'),
  PublicNotice: () => import(/* webpackChunkName: "train" */ '@/views/notice.vue'),
  ShowIncome: () => import(/* webpackChunkName: "docs" */ '@/views/docs/showIncome.vue'),
  TrainV3: () => import(/* webpackChunkName: "train" */ '@/views/task/trainV3.vue'),
};


